import form from '@/mixins/crud-form';
import utils from '@/utils';
export default {
  mixins: [form],
  data: function data() {
    return {
      api: {
        detail: 'DEVICE_SERVICE_BUY_RULES_DETAIL',
        create: 'DEVICE_SERVICE_BUY_RULES_CREATE',
        update: 'DEVICE_SERVICE_BUY_RULES_UPDATE'
      },
      dialog: {
        width: '900px',
        height: '900px'
      }
    };
  },
  computed: {
    setting: function setting() {
      var _this = this;

      var h = this.$createElement;
      return [{
        prop: 'timelong',
        default: '',
        label: 'timelong',
        col: {
          span: 16
        },
        render: function render() {
          return h("el-input", {
            "model": {
              value: _this.form.model.timelong,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "timelong", $$v);
              }
            }
          });
        }
      }, {
        prop: 'amount',
        default: '',
        label: 'amount',
        col: {
          span: 16
        },
        render: function render() {
          return h("el-input", {
            "model": {
              value: _this.form.model.amount,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "amount", $$v);
              }
            }
          });
        }
      }, {
        prop: 'price',
        default: '',
        label: 'price',
        col: {
          span: 16
        },
        render: function render() {
          return h("el-input", {
            "model": {
              value: _this.form.model.price,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "price", $$v);
              }
            }
          });
        }
      }, {
        prop: 'discount',
        default: '',
        label: 'discount',
        col: {
          span: 16
        },
        render: function render() {
          return h("el-input", {
            "model": {
              value: _this.form.model.discount,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "discount", $$v);
              }
            }
          });
        }
      }];
    }
  },
  methods: {}
};